import React from 'react';
import './OrderModal.css';

export default function OrderModal({ order, images, onClose }) {
  const [current, setCurrent] = React.useState(0);

  if (!order) return null;

  const handlePrev = () => setCurrent((c) => (c === 0 ? images.length - 1 : c - 1));
  const handleNext = () => setCurrent((c) => (c === images.length - 1 ? 0 : c + 1));

  return (
    <div className="order-modal-overlay" onClick={onClose}>
      <div className="order-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="order-info">
          <h3>Order #{order.orderNumber}</h3>
          <div><b>Date:</b> {order.orderDate}</div>
          <div><b>Name:</b> {order.name}</div>
          <div><b>Last Name:</b> {order.last_name}</div>
          <div><b>Place:</b> {order.place}</div>
          <div><b>Address:</b> {order.address}</div>
          <div><b>Phone:</b> {order.phone}</div>
          <div><b>Comment:</b> {order.comment}</div>
          <div><b>Product Name:</b> {order.product_name}</div>
          <div><b>Price:</b> {order.price}</div>
          <div><b>Pages:</b> {order.pages}</div>
        </div>
        <div className="slideshow">
          <button className="nav-btn" onClick={handlePrev}>‹</button>
          <img src={images[current]} alt={`Order ${order.orderNumber} - ${current + 1}`} className="slide-img" />
          <button className="nav-btn" onClick={handleNext}>›</button>
        </div>
        <div className="slide-indicator">{current + 1} / {images.length}</div>
      </div>
    </div>
  );
}
